import { Routes, Route } from 'react-router-dom'
import { Link } from 'react-router-dom'
import { Floater } from 'components'

import MemberIntro from './MemberIntro'
import TermsCheck from './TermsCheck'
import TermsLayer from './TermsLayer'
import Join from './Join'
import JoinNumber from './JoinNumber'
import JoinEmail from './JoinEmail'
import JoinPassword from './JoinPassword'
import JoinPasswordExisting from './JoinPasswordExsiting'
import Login from './login'
import JoinSuccess from './JoinSuccess'
import JoinConfirm from './JoinConfirm'
import JoinLogout from './JoinLogout'
import JoinBio from './JoinBio'

import AppError1 from './AppError1'
import AppError2 from './AppError2'
import AppError3 from './AppError3'
import NotFound from 'views/NotFound'
import LoginGoData from "./login/LoginGoData";
import DormantCheck from './DormantCheck'

// member
const Index = () => {

	return (
		<>
			<Floater>
				<li><Link to="">회원가입 진입(서비스 소개)</Link></li>
				<li><Link to="termsCheck">회원가입 약관동의</Link></li>
				<li><Link to="termsLayer">회원가입 약관 상세보기</Link></li>
				<li><Link to="join">회원가입</Link></li>
				<li><Link to="joinNumber">회원가입 인증번호</Link></li>
				<li><Link to="joinEmail">회원가입 이메일</Link></li>
				<li><Link to="joinPassword">회원가입 비밀번호 입력</Link></li>
				<li><Link to="joinPasswordExisting">회원가입 비밀번호 입력 (기존 회원일 경우)</Link></li>
				<li><Link to="joinSuccess">회원가입 가입완료</Link></li>
				<li><Link to="joinConfirm">로그인 비밀번호 재설정</Link></li>
				<li><Link to="joinLogout">로그인 연장</Link></li>
				<li><Link to="joinBio">로그인 생체정보</Link></li>
				<li><Link to="appError1">앱오류 1</Link></li>
				<li><Link to="appError2">앱오류 2</Link></li>
				<li><Link to="appError3">앱오류 3</Link></li>
			</Floater>
			<Routes>
				<Route path="/login" element={<Login />} /> { /* 회원 로그인 */}
				<Route path="/loginGoData" element={<LoginGoData />} /> { /* 회원 로그인 */}
				<Route path="/dormantCheck" element={<DormantCheck />} /> { /* 휴면해제 */}

				<Route path="/termsCheck" element={<TermsCheck />} /> { /* 회원가입 약관동의 */}
				<Route path="/termsLayer" element={<TermsLayer />} /> { /* 회원가입 약관 상세보기 */}
				<Route path="/join" element={<Join />} /> { /* 회원가입 */}
				<Route path="/joinNumber" element={<JoinNumber />} /> { /* 회원가입 인증번호 */}
				<Route path="/joinEmail" element={<JoinEmail />} /> { /* 회원가입 이메일 */}
				<Route path="/joinPassword" element={<JoinPassword />} /> { /* 회원가입 비밀번호 입력 */}
				<Route path="/joinPasswordExisting" element={<JoinPasswordExisting />} /> { /* 회원가입 비밀번호 입력 (기존 회원일 경우) */}
				<Route path="/joinSuccess" element={<JoinSuccess />} /> { /* 회원가입 가입완료 */}
				<Route path="/joinConfirm" element={<JoinConfirm />} /> { /* 로그인 비밀번호 재설정 */}
				<Route path="/joinLogout" element={<JoinLogout />} /> { /* 로그인 연장 */}
				<Route path="/joinBio" element={<JoinBio />} /> { /* 로그인 생체정보 */}
				<Route path="/appError1" element={<AppError1 />} /> { /* 앱오류1 */}
				<Route path="/appError2" element={<AppError2 />} /> { /* 앱오류2 */}
				<Route path="/appError3" element={<AppError3 />} /> { /* 앱오류3 */}
				<Route path="*" element={<MemberIntro />} /> { /* 회원가입 진입(서비스 소개) */}
				<Route path="*" element={<NotFound />} />
			</Routes>
		</>
	)
}

export default Index